import { apiClient } from './client'

export interface LoginRequest {
  email: string
  password: string
  remember_me?: boolean
}

export interface LoginResponse {
  user?: any
  access_token?: string
  refresh_token?: string
  token_type?: string
  expires_in?: number
  session_id?: string
  session_expires_at?: string
  requires_2fa?: boolean
  requires_2fa_setup?: boolean
  temp_token?: string
}

export interface TOTPSetupResponse {
  secret: string
  qr_code: string
  provisioning_uri: string
}

export interface RefreshTokenResponse {
  access_token: string
  token_type: string
  expires_in: number
}

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post('/auth/login', data)
    return response.data
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout')
  },

  refreshToken: async (token?: string): Promise<RefreshTokenResponse> => {
    const response = await apiClient.post('/auth/refresh', token ? { refresh_token: token } : {})
    return response.data
  },

  getCurrentUser: async (): Promise<any> => {
    const response = await apiClient.get('/users/me')
    return response.data
  },

  verifyToken: async (): Promise<any> => {
    const response = await apiClient.get('/auth/verify')
    return response.data
  },

  getSessions: async (): Promise<any> => {
    const response = await apiClient.get('/auth/sessions')
    return response.data
  },

  revokeSession: async (sessionId: string): Promise<void> => {
    await apiClient.delete(`/auth/sessions/${sessionId}`)
  },

  verify2FA: async (tempToken: string, code: string): Promise<LoginResponse> => {
    const response = await apiClient.post('/auth/2fa/verify', {
      temp_token: tempToken,
      code,
    })
    return response.data
  },

  setup2FA: async (tempToken?: string): Promise<TOTPSetupResponse> => {
    const response = await apiClient.post('/auth/2fa/setup', {
      temp_token: tempToken,
    })
    return response.data
  },

  confirm2FA: async (code: string, tempToken?: string): Promise<LoginResponse> => {
    const response = await apiClient.post('/auth/2fa/setup/confirm', {
      code,
      temp_token: tempToken,
    })
    return response.data
  },
}

// Export individual functions for convenience
export const login = authApi.login
export const logout = authApi.logout
export const refreshToken = authApi.refreshToken
